import { Component, OnInit } from '@angular/core';
import { PageTitleService } from '../../../shared/services';

@Component({
  selector: 'app-account-setting',
  imports: [],
  templateUrl: './account-setting.html',
  styleUrl: './account-setting.css',
})
export class AccountSetting implements OnInit {
  constructor(private titleService: PageTitleService) {}

  ngOnInit(): void {
    this.titleService.setPage({
      title: 'Tu cuenta',
      subtitle: 'Seguridad y preferencias de tu cuenta',
    });
  }
}
